import { Route, Routes } from 'react-router-dom';

import { DefaultLayout2 } from '@web/app/shared';

import { MarketplacePage } from '../pages/MarketplacePage';

export const MarketplaceRoutes = () => {
    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path="/" element={<MarketplacePage />} />
            </Route>
        </Routes>
    );
};
